import type { ClientDto } from '../dto';
import type { Client } from '../models';

export const mapClientDtoToModel = (dto: ClientDto): Client => ({
  ...dto,
  accounts: dto.accounts ?? [],
});

export const mapClientListDtoToModel = (dto: ClientDto[]): Client[] =>
  dto.map(mapClientDtoToModel);
